import { Fragment, useCallback, useState } from 'react';
import { useEffect } from 'react';
import { Switch } from "@progress/kendo-react-inputs";
import { Chart, ChartLegend, ChartArea, ChartTooltip, ChartSeries, ChartSeriesItem } from '@progress/kendo-react-charts';
import 'hammerjs';
import { ExpansionPanel, ExpansionPanelContent } from '@progress/kendo-react-layout';
import ReportService from '../Services/ReportService';
import SweetAlertService from '../../../services/SweetAlertService';
import { AppConstants } from '../Shared/Constants/AppConstant';

export const AverageWeek = (props: any) => {

    //category and subcategory
    const [categories, setCategories] = useState<any>([])
    const [subCategories, setSubCategories] = useState<any>([])
    const [categoriesCopy, setCategoriesCopy] = useState<any>([]);
    const [subCategoriesCopy, setSubCategoriesCopy] = useState<any>([]);

    //total hours minutes
    const [totalHours, setTotalHours] = useState<any>();
    const [totalMinutes, setTotalMinutes] = useState<any>();

    //total Session
    const [totalSessions, setTotalSessions] = useState<any>();
    const [clickedSegment, setClickedSegment] = useState<any>({ name: "", totalHours: 0, totalMinutes: 0, id: 0 });

    //For Legends
    const [expanded, setExpanded] = useState<any>();

    //DCC and ICC exceeded
    const [dccExceedsContracted, setDccExceedsContracted] = useState(false);
    const [iccDccExceedsContracted, setIccDccExceedsContracted] = useState(false);

    //ICC and Contract Percentage
    const [iccPercentage, setIccPercentage] = useState<any>();
    const [contractPercentage, setContractPercentage] = useState<any>();

    //Aggregate Contract and Worked Percentage
    const [aggregateContractPercentage, setAggregateContractPercentage] = useState<any>();

    //Aggregate ICC and DCC Percentage
    const [aggregateIccDccPercentage, setAggregateIccDccPercentage] = useState<any>();

    //Exclude Public Holiday
    const [isExcludePublicHolidayToggelChecked, setIsExcludePublicHolidayToggelChecked] = useState<any>(false);
    const [isPublicHolidayExistInPeriod, setIsPublicHolidayExistInPeriod] = useState<any>(false);
    const [isPublicHolidayExistsInAllWeeks, setIsPublicHolidayExistsInAllWeeks] = useState<any>(false);
    const [showErrorMessageForPublicHolidayToggle, setShowErrorMessageForPublicHolidayToggle] = useState<any>(false);

    //Exclude Leave
    const [isLeaveExistInPeriod, setIsLeaveExistInPeriod] = useState<any>(false);
    const [isLeaveExistsInAllWeeks, setIsLeaveExistsInAllWeeks] = useState<any>(false);
    const [isExcludeLeaveToggelChecked, setIsExcludeLeaveToggelChecked] = useState<any>(false);
    const [showErrorMessageForLeaveToggle, setShowErrorMessageForLeaveToggle] = useState<any>(false);

    //To set subcatgories
    let subCategoriesToSetForDefaultValue: any = [];

    const [averageWeekResponse, setAverageWeekResponse] = useState<any>();

    //To set chart data
    const setChartData = (categories: any, subCategories: any, totalHours: any, totalMinutes: any, totalSessions: any, dccExceedsContracted: any, iccPercentage: any, aggregateContractPercentage: any, aggregateIccDccPercentage: any, contractPercentage: any, iccDccExceedsContracted: any, isPublicHolidayToggelChecked: any, isLeaveToggelChecked: any) => {
        subCategoriesToSetForDefaultValue = [];
        categories.map((element: any) => {
            element.color = getColorForCategory(element, subCategories);
        });
        setCategories(categories);
        setCategoriesCopy(JSON.parse(JSON.stringify(categories)));
        setSubCategories(subCategories);
        setSubCategoriesCopy(JSON.parse(JSON.stringify(subCategoriesToSetForDefaultValue)));
        setTotalHours(totalHours);
        setTotalMinutes(totalMinutes);
        setTotalSessions(totalSessions);
        setDccExceedsContracted(dccExceedsContracted);
        setIccDccExceedsContracted(iccDccExceedsContracted);
        setIccPercentage(iccPercentage);
        setContractPercentage(contractPercentage);
        setAggregateContractPercentage(aggregateContractPercentage);
        setAggregateIccDccPercentage(aggregateIccDccPercentage);
        const expand: any = categories.reduce(
            (acc: any, cur: any) => ({ ...acc, [cur.id]: true }),
            {}
        );
        setExpanded({ ...expand });
        //For report pdf
        props.setAverageWeekData(
            {
                categories: JSON.parse(JSON.stringify(categories)), subCategories: JSON.parse(JSON.stringify(subCategories)), totalHours: totalHours, totalMinutes: totalMinutes,
                totalSessions: totalSessions, dccExceedsContracted: dccExceedsContracted, iccDccExceedsContracted: iccDccExceedsContracted,
                iccPercentage: iccPercentage, contractPercentage: contractPercentage, aggregateContractPercentage: aggregateContractPercentage,
                aggregateIccDccPercentage: aggregateIccDccPercentage,
                isPublicHolidayToggelChecked: isPublicHolidayToggelChecked,
                isLeaveToggelChecked: isLeaveToggelChecked
            }
        );
    }

    useEffect(() => {
        getAverageWeekDetails();
    }, []);

    //categories for no data
    const weekWithNoCategoriesData = [
        { id: 1, name: "", totalHours: 0, totalMinutes: 0, color: "rgb(191,191,191)", totalSessions: 100, totalDurationMinutes: 100, percentage: 0, isUserDefined: false }
    ];
    //sub-categories for no data
    const weekWithNoSubCategoriesData = [
        { id: 1, categoryId: AppConstants.DCC_Category_Id, name: "", categoryName: "", color: "rgb(191,191,191)", totalHours: 0, totalMinutes: 0, totalSessions: 50, totalDurationMinutes: 50, percentage: 0, isUserDefined: false },
        { id: 2, categoryId: AppConstants.DCC_Category_Id, name: "", categoryName: "", color: "rgb(191,191,191)", totalHours: 0, totalMinutes: 0, totalSessions: 50, totalDurationMinutes: 50, percentage: 0, isUserDefined: false },
    ];

    //To build data for chart
    const BuildChartForNoDataFound = (isPublicHolidayToggelChecked: any, isLeaveToggelChecked: any) => {
        setCategories(weekWithNoCategoriesData);
        setCategoriesCopy(JSON.parse(JSON.stringify(weekWithNoCategoriesData)));
        setSubCategories(weekWithNoSubCategoriesData);
        setSubCategoriesCopy(JSON.parse(JSON.stringify(weekWithNoSubCategoriesData)));
        setTotalHours(0);
        setTotalMinutes(0);
        setTotalSessions(0);
        setDccExceedsContracted(false);
        setIccDccExceedsContracted(false);
        setIccPercentage(0);
        setContractPercentage(0);
        setAggregateContractPercentage(0);
        setAggregateIccDccPercentage(0);
        const expand: any = weekWithNoCategoriesData.reduce(
            (acc: any, cur: any) => ({ ...acc, [cur.id]: true }),
            {}
        );
        setExpanded({ ...expand });
        props.setAverageWeekData(
            {
                categories: weekWithNoCategoriesData, subCategories: weekWithNoSubCategoriesData, totalHours: 0, totalMinutes: 0,
                totalSessions: 0, dccExceedsContracted: false, iccDccExceedsContracted: false,
                iccPercentage: 0, contractPercentage: 0, aggregateContractPercentage: 0,
                aggregateIccDccPercentage: 0,
                isPublicHolidayToggelChecked: isPublicHolidayToggelChecked,
                isLeaveToggelChecked: isLeaveToggelChecked
            }
        );
    }

    //Set orginal data
    const setAllData = (averageData: any) => {
        if (averageData.categoryDto.length > 0) {
            setChartData(averageData.categoryDto, averageData.subCategoryDto, averageData.totalHours, averageData.totalMinutes, averageData.totalSessions, averageData.isDccExceeded, averageData.iccPercentage, averageData.aggregateContractAndWorkedTotalPercentage, averageData.aggregateIccDccPercentage, averageData.contractPercentage, averageData.isDccAndIccExceeded,false,false);
        } else {
            //When no data exists
            BuildChartForNoDataFound(false, false);
        }
    }

    const getAverageWeekDetails = () => {
        let payload: any = {};
        payload.startDate = new Date(props.startDate.getFullYear(), props.startDate.getMonth(), props.startDate.getDate(), 0, 0, 0);
        payload.endDate = new Date(props.endDate.getFullYear(), props.endDate.getMonth(), props.endDate.getDate(), 23, 59, 59);
        payload.employerID = props.employerID;
        ReportService.getAverageWeekDetails(payload).then((response: any) => {
            if (response) {
                var averageData = response.data;
                setAverageWeekResponse(response.data);

                //When leave and public holiday exists in all week  
                if (averageData.isLeaveExistsInAllWeeks && averageData.isPublicHolidayExistsInAllWeeks) {
                    setAllData(averageData);
                    setIsLeaveExistsInAllWeeks(true);
                    setIsPublicHolidayExistsInAllWeeks(true);
                }
                //When leave exists in all week 
                else if (averageData.isLeaveExistsInAllWeeks) {
                    setIsLeaveExistsInAllWeeks(true);
                    //When public holiday exists 
                    if (averageData.isPublicHolidayExistInPeriod) {
                        if (averageData.excludingPublicHolidaysCategories.length > 0) {
                            setChartData(averageData.excludingPublicHolidaysCategories, averageData.excludingPublicHolidaysSubCategories, averageData.totalHoursExcludingPublicHolidays, averageData.totalMinutesExcludingPublicHolidays, averageData.totalSessionsExcludingPublicHolidays, averageData.excludePublicHolidayIsDccExceeded, averageData.excludePublicHolidayIccPercentage, averageData.excludePublicHolidayAggregateContractAndWorkedPercentage, averageData.excludePublicHolidayAggregateIccDccPercentage, averageData.excludePublicHolidayContractPercentage, averageData.excludePublicHolidayIsDccAndIccExceeded,true,false);
                        } else {
                            //When no data exists
                            BuildChartForNoDataFound(true, false);
                        }
                        setIsPublicHolidayExistInPeriod(true);
                        setIsExcludePublicHolidayToggelChecked(true);
                    } else {
                        setAllData(averageData);
                    }
                    //When public holiday exists in all week
                } else if (averageData.isPublicHolidayExistsInAllWeeks) {
                    setIsPublicHolidayExistsInAllWeeks(true);
                    if (averageData.isLeaveExistInPeriod) {
                        if (averageData.excludingLeaveCategories.length > 0) {
                            setChartData(averageData.excludingLeaveCategories, averageData.excludingLeaveSubCategories, averageData.totalHoursExcludingLeaves, averageData.totalMinutesExcludingLeaves, averageData.totalSessionsExcludingLeaves, averageData.excludeLeaveIsDccExceeded, averageData.excludeLeaveIccPercentage, averageData.excludeLeaveAggregateContractAndWorkedPercentage, averageData.excludeLeaveAggregateIccDccPercentage, averageData.excludeLeaveContractPercentage, averageData.excludeLeaveIsDccAndIccExceeded,false,true);
                        } else {
                            //When no data exists
                            BuildChartForNoDataFound(false, true);
                        }
                        setIsLeaveExistInPeriod(true);
                        setIsExcludeLeaveToggelChecked(true);
                    } else {
                        setAllData(averageData);
                    }
                }
                if (!averageData.isLeaveExistsInAllWeeks && !averageData.isPublicHolidayExistsInAllWeeks) {
                    //When public holiday and leave exists 
                    if (averageData.isLeaveExistInPeriod && averageData.isPublicHolidayExistInPeriod) {
                        setIsLeaveExistInPeriod(true);
                        setIsExcludeLeaveToggelChecked(true);
                        setIsPublicHolidayExistInPeriod(true);
                        setIsExcludePublicHolidayToggelChecked(true);
                        if (averageData.excludingLeaveAndPublicHolidaysCategories.length > 0) {
                            setChartData(averageData.excludingLeaveAndPublicHolidaysCategories, averageData.excludingLeaveAndPublicHolidaysSubCategories, averageData.totalHoursExcludingLeavesAndPublicHoliday, averageData.totalMinutesExcludingLeavesAndPublicHoliday, averageData.totalSessionsExcludingLeavesAndPublicHoliday, averageData.excludeLeaveAndPublicHolidayIsDccExceeded, averageData.excludePublicHolidayAndLeaveIccPercentage, averageData.excludeLeaveAndPublicHolidayAggregateContractAndWorkedPercentage, averageData.excludeLeaveAndPublicHolidayAggregateIccDccPercentage, averageData.excludePublicHolidayAndLeaveContractPercentage, averageData.excludeLeaveAndPublicHolidayIsDccAndIccExceeded,true,true);
                        } else {
                            //When no data exists
                            BuildChartForNoDataFound(true, true);
                        }
                    }
                    //When public leave exists 
                    else if (averageData.isLeaveExistInPeriod) {
                        if (averageData.excludingLeaveCategories.length > 0) {
                            setChartData(averageData.excludingLeaveCategories, averageData.excludingLeaveSubCategories, averageData.totalHoursExcludingLeaves, averageData.totalMinutesExcludingLeaves, averageData.totalSessionsExcludingLeaves, averageData.excludeLeaveIsDccExceeded, averageData.excludeLeaveIccPercentage, averageData.excludeLeaveAggregateContractAndWorkedPercentage, averageData.excludeLeaveAggregateIccDccPercentage, averageData.excludeLeaveContractPercentage, averageData.excludeLeaveIsDccAndIccExceeded,false,true);
                        } else {
                            //When no data exists
                            BuildChartForNoDataFound(false, true);
                        }
                        setIsLeaveExistInPeriod(true);
                        setIsExcludeLeaveToggelChecked(true);
                    }
                    //When public holiday exists 
                    else if (averageData.isPublicHolidayExistInPeriod) {
                        if (averageData.excludingPublicHolidaysCategories.length > 0) {
                            setChartData(averageData.excludingPublicHolidaysCategories, averageData.excludingPublicHolidaysSubCategories, averageData.totalHoursExcludingPublicHolidays, averageData.totalMinutesExcludingPublicHolidays, averageData.totalSessionsExcludingPublicHolidays, averageData.excludePublicHolidayIsDccExceeded, averageData.excludePublicHolidayIccPercentage, averageData.excludePublicHolidayAggregateContractAndWorkedPercentage, averageData.excludePublicHolidayAggregateIccDccPercentage, averageData.excludePublicHolidayContractPercentage, averageData.excludePublicHolidayIsDccAndIccExceeded,true,false);
                        } else {
                            //When no data exists
                            BuildChartForNoDataFound(true, false);
                        }
                        setIsPublicHolidayExistInPeriod(true);
                        setIsExcludePublicHolidayToggelChecked(true);
                    }
                    else {
                        setAllData(averageData);
                    }
                }
            }
        })
            .catch((error: any) => {
                console.log(error);
                SweetAlertService.error("Error", "Something went wrong while loading average week chart");
            });
    }


    //To get color for category
    const getColorForCategory = (category: any, subCategoryList: any) => {
        let subcategories = subCategoryList.filter((x: { categoryId: any; }) => x.categoryId == category.id);
        let total = 10 / subcategories.length;

        subcategories.forEach((element: any, index: any) => {
            let opacity = (total * (subcategories.length - index)) / 10;
            element.color = getColorForSubCategory(element, opacity);
            subCategoriesToSetForDefaultValue.push(element);
        });

        let map: any = {
            [AppConstants.DCC_Category_Id]: '#0967B1',
            [AppConstants.ICC_Category_Id]: '#DA1F6C',
            [AppConstants.Non_Clinical_Work_Category_Id]: '#008E82',
            [AppConstants.Training_And_Supervision_Category_Id]: '#6F4F9B',
            [AppConstants.CPD_Category_Id]: '#EA580D',
            [AppConstants.Academic_Category_Id]: '#000000',
        };

        if (category.isUserDefined) {
            return '#76A227';
        } else {
            return map[category.id];
        }
    }

    //To get color for subcategory
    const getColorForSubCategory = (element: any, opacity: any) => {
        let alpha = opacity - 0.1;
        let map: any = {
            [AppConstants.DCC_Category_Id]: 'rgba(137, 207, 240,' + alpha + ')',
            [AppConstants.ICC_Category_Id]: 'rgba(218, 31, 108,' + alpha + ')',
            [AppConstants.Non_Clinical_Work_Category_Id]: 'rgba(0, 142, 130,' + alpha + ')',
            [AppConstants.Training_And_Supervision_Category_Id]: 'rgba(111, 79, 155,' + alpha + ')',
            [AppConstants.CPD_Category_Id]: 'rgba(234, 88, 13,' + alpha + ')',
            [AppConstants.Academic_Category_Id]: 'rgba(0, 0, 0,' + alpha + ')',
        };

        if (element.isUserDefined) {
            return 'rgba(118, 162, 39,' + alpha + ')';
        } else {
            return map[element.categoryId];
        }
    }

    const onAction = useCallback(
        (id: any) => {
            setExpanded({ ...expanded, [id]: !expanded[id] });
        },
        [expanded]
    );

    //donut center circle values
    const donutCenterRenderer = () => (
        <span>
            {clickedSegment.name ? (
                <div>
                    <h4 className="text-dark">{Math.floor(clickedSegment.totalHours)}h {clickedSegment.totalMinutes.toFixed(1)}m</h4>
                    <h3 className="text-dark">{clickedSegment.name}</h3>
                </div>
            ) : (
                <div>
                    <h2>{Math.floor(totalHours)}h {totalMinutes.toFixed(1)}m</h2>
                </div>
            )}
        </span>
    );

    //Donut chart OnClick state
    const onSeriesClick = (event: any) => {
        if (totalSessions > 0) {
            const { category, series } = event.point;
            let categoryId = event.series.name == "categories" ? event.dataItem.id : event.dataItem.categoryId;
            var map: any = {
                [AppConstants.DCC_Category_Id]: 'rgba(137, 207, 240,0.2)',
                [AppConstants.ICC_Category_Id]: 'rgba(218, 31, 108,0.2)',
                [AppConstants.Non_Clinical_Work_Category_Id]: 'rgba(0, 142, 130,0.2)',
                [AppConstants.Training_And_Supervision_Category_Id]: 'rgba(111, 79, 155,0.2)',
                [AppConstants.CPD_Category_Id]: 'rgba(234, 88, 13,0.2)',
                [AppConstants.Academic_Category_Id]: 'rgba(0, 0, 0,0.2)',
            };
            var mapO: any = {
                [AppConstants.DCC_Category_Id]: '#0967B1',
                [AppConstants.ICC_Category_Id]: '#DA1F6C',
                [AppConstants.Non_Clinical_Work_Category_Id]: '#008E82',
                [AppConstants.Training_And_Supervision_Category_Id]: '#6F4F9B',
                [AppConstants.CPD_Category_Id]: '#EA580D',
                [AppConstants.Academic_Category_Id]: '#000000'
            };
            categories.forEach((element: any) => {
                if (element.id != categoryId) {
                    element.color = element.isUserDefined ? 'rgba(118, 162, 39, 0.2)' : map[element.id];
                } else {
                    element.color = element.isUserDefined ? '#76A227' : mapO[element.id];
                }
            });
            let alpha = 0.2;
            var mapSubCategory: any = {
                [AppConstants.DCC_Category_Id]: 'rgba(137, 207, 240,' + alpha + ')',
                [AppConstants.ICC_Category_Id]: 'rgba(218, 31, 108,' + alpha + ')',
                [AppConstants.Non_Clinical_Work_Category_Id]: 'rgba(0, 142, 130,' + alpha + ')',
                [AppConstants.Training_And_Supervision_Category_Id]: 'rgba(111, 79, 155,' + alpha + ')',
                [AppConstants.CPD_Category_Id]: 'rgba(234, 88, 13,' + alpha + ')',
                [AppConstants.Academic_Category_Id]: 'rgba(0, 0, 0,' + alpha + ')',
            };
            subCategories.forEach((element: any, index: any) => {
                if (element.categoryId != categoryId) {
                    element.color = element.isUserDefined ? 'rgba(118, 162, 39,' + alpha + ')' : mapSubCategory[element.categoryId]
                } else {
                    element.color = getSubCategoryOriginalColor(element.id);
                }
            });
            const clickedDataItem = series.data.find((item: any) => item.name === category);

            if (clickedDataItem) {
                // Set the clicked segment's data
                setClickedSegment({
                    name: clickedDataItem.name,
                    totalHours: clickedDataItem.totalHours,
                    totalMinutes: clickedDataItem.totalMinutes,
                    id: clickedDataItem.id,
                });
            }
            setCategories(categories);
            setSubCategories(subCategories);
        }
    }

    //To get original colour for sub-categories in donut chart
    const getSubCategoryOriginalColor = (subCategoryId: any) => {
        if (totalSessions > 0) {
            let ele = subCategoriesCopy.filter((x: { id: any; }) => x.id == subCategoryId)[0];
            return ele.color;
        }
    }

    //To reset the chart on click of chart
    const reset = () => {
        if (totalSessions >= 0) {
            setCategories(JSON.parse(JSON.stringify(categoriesCopy)));
            setSubCategories(JSON.parse(JSON.stringify(subCategoriesCopy)));
            setClickedSegment({});
        }
    }

    //To reset all the values of chart
    const resetChartData = () => {
        setCategories([]);
        setCategoriesCopy([]);
        setSubCategories([]);
        setSubCategoriesCopy([]);
        setTotalHours(0);
        setTotalMinutes(0);
        setTotalSessions(0);
        setDccExceedsContracted(false);
        setIccDccExceedsContracted(false);
        setIccPercentage(0);
        setContractPercentage(0);
        setAggregateContractPercentage(0);
        setAggregateIccDccPercentage(0);
        setExpanded({});
        setClickedSegment({});
    }

    //To get the tooltip with data
    const renderTooltip = (context: any) => {
        if (totalSessions > 0) {
            const { category, series } = context.point || context; // Extract category and series information
            const dataItem = series.data.find((item: any) => item.name === category);
            return (
                <div>
                    <p className="mb-2"> {category}</p>
                    <p className="mb-2">{dataItem.totalSessions.toFixed(2)} sessions</p>
                    <p className="mb-2"> {dataItem.totalHours}h {dataItem.totalMinutes.toFixed(1)}m</p>
                    <p className="mb-2"> {dataItem.percentage?.toFixed(1)}%</p>
                </div>
            )
        }
    };

    //Avoid lightening on hover 
    const handleOnHoverState = (e: any) => {
        e.point.options.highlight.visible = false
    }

    //To call method when user change the values of Public holiday toggle
    const onExcludePublicHolidayChange = (event: any) => {
        if (isPublicHolidayExistsInAllWeeks) {
            setShowErrorMessageForPublicHolidayToggle(true);
        }
        else {
            reset();
            resetChartData();
            setShowErrorMessageForLeaveToggle(false);
            setIsExcludePublicHolidayToggelChecked(event.value);
            let averageData = averageWeekResponse;

            //When public holiday and leave exists 
            if (event.value && isExcludeLeaveToggelChecked) {
                if (averageData.excludingLeaveAndPublicHolidaysCategories.length > 0) {
                    setChartData(averageData.excludingLeaveAndPublicHolidaysCategories, averageData.excludingLeaveAndPublicHolidaysSubCategories, averageData.totalHoursExcludingLeavesAndPublicHoliday, averageData.totalMinutesExcludingLeavesAndPublicHoliday, averageData.totalSessionsExcludingLeavesAndPublicHoliday, averageData.excludeLeaveAndPublicHolidayIsDccExceeded, averageData.excludePublicHolidayAndLeaveIccPercentage, averageData.excludeLeaveAndPublicHolidayAggregateContractAndWorkedPercentage, averageData.excludeLeaveAndPublicHolidayAggregateIccDccPercentage, averageData.excludePublicHolidayAndLeaveContractPercentage, averageData.excludeLeaveAndPublicHolidayIsDccAndIccExceeded,true,true);
                } else {
                    //When no data exists
                    BuildChartForNoDataFound(true, true);
                }
            }
            //When public holiday exists 
            else if (event.value) {
                if (averageData.excludingPublicHolidaysCategories.length > 0) {
                    setChartData(averageData.excludingPublicHolidaysCategories, averageData.excludingPublicHolidaysSubCategories, averageData.totalHoursExcludingPublicHolidays, averageData.totalMinutesExcludingPublicHolidays, averageData.totalSessionsExcludingPublicHolidays, averageData.excludePublicHolidayIsDccExceeded, averageData.excludePublicHolidayIccPercentage, averageData.excludePublicHolidayAggregateContractAndWorkedPercentage, averageData.excludePublicHolidayAggregateIccDccPercentage, averageData.excludePublicHolidayContractPercentage, averageData.excludePublicHolidayIsDccAndIccExceeded,true,false);
                } else {
                    //When no data exists
                    BuildChartForNoDataFound(true, false);
                }
            }
            //When leave exists 
            else if (isExcludeLeaveToggelChecked) {
                if (averageData.excludingLeaveCategories.length > 0) {
                    setChartData(averageData.excludingLeaveCategories, averageData.excludingLeaveSubCategories, averageData.totalHoursExcludingLeaves, averageData.totalMinutesExcludingLeaves, averageData.totalSessionsExcludingLeaves, averageData.excludeLeaveIsDccExceeded, averageData.excludeLeaveIccPercentage, averageData.excludeLeaveAggregateContractAndWorkedPercentage, averageData.excludeLeaveAggregateIccDccPercentage, averageData.excludeLeaveContractPercentage, averageData.excludeLeaveIsDccAndIccExceeded,false,true);
                } else {
                    //When no data exists
                    BuildChartForNoDataFound(false, true);
                }
            } else {
                setAllData(averageData);
            }
        }
    }


    //To call method when user change the values of Leave toggele
    const onExcludeLeaveChange = (event: any) => {
        if (isLeaveExistsInAllWeeks) {
            setShowErrorMessageForLeaveToggle(true);
        }
        else {
            reset();
            resetChartData();
            setShowErrorMessageForPublicHolidayToggle(false);
            let averageData = averageWeekResponse;
            setIsExcludeLeaveToggelChecked(event.value);
            //When public holiday and leave exists 
            if (event.value && isExcludePublicHolidayToggelChecked) {
                if (averageData.excludingLeaveAndPublicHolidaysCategories.length > 0) {
                    setChartData(averageData.excludingLeaveAndPublicHolidaysCategories, averageData.excludingLeaveAndPublicHolidaysSubCategories, averageData.totalHoursExcludingLeavesAndPublicHoliday, averageData.totalMinutesExcludingLeavesAndPublicHoliday, averageData.totalSessionsExcludingLeavesAndPublicHoliday, averageData.excludeLeaveAndPublicHolidayIsDccExceeded, averageData.excludePublicHolidayAndLeaveIccPercentage, averageData.excludeLeaveAndPublicHolidayAggregateContractAndWorkedPercentage, averageData.excludeLeaveAndPublicHolidayAggregateIccDccPercentage, averageData.excludePublicHolidayAndLeaveContractPercentage, averageData.excludeLeaveAndPublicHolidayIsDccAndIccExceeded,true,true);
                } else {
                    //When no data exists
                    BuildChartForNoDataFound(true, true);
                }
            }
            //When leave exists 
            else if (event.value) {
                if (averageData.excludingLeaveCategories.length > 0) {
                    setChartData(averageData.excludingLeaveCategories, averageData.excludingLeaveSubCategories, averageData.totalHoursExcludingLeaves, averageData.totalMinutesExcludingLeaves, averageData.totalSessionsExcludingLeaves, averageData.excludeLeaveIsDccExceeded, averageData.excludeLeaveIccPercentage, averageData.excludeLeaveAggregateContractAndWorkedPercentage, averageData.excludeLeaveAggregateIccDccPercentage, averageData.excludeLeaveContractPercentage, averageData.excludeLeaveIsDccAndIccExceeded,false,true);
                } else {
                    //When no data exists
                    BuildChartForNoDataFound(false, true);
                }
            }
            //When public holiday exists 
            else if (isExcludePublicHolidayToggelChecked) {
                if (averageData.excludingPublicHolidaysCategories.length > 0) {
                    setChartData(averageData.excludingPublicHolidaysCategories, averageData.excludingPublicHolidaysSubCategories, averageData.totalHoursExcludingPublicHolidays, averageData.totalMinutesExcludingPublicHolidays, averageData.totalSessionsExcludingPublicHolidays, averageData.excludePublicHolidayIsDccExceeded, averageData.excludePublicHolidayIccPercentage, averageData.excludePublicHolidayAggregateContractAndWorkedPercentage, averageData.excludePublicHolidayAggregateIccDccPercentage, averageData.excludePublicHolidayContractPercentage, averageData.excludePublicHolidayIsDccAndIccExceeded,true,false);
                } else {
                    //When no data exists
                    BuildChartForNoDataFound(true, false);
                }
            } else {
                setAllData(averageData);
            }
        }
    }

    // To hide the error messages when user clicks on white space
    const hideErrorMessagesForLeaveAndPublicHoliday = () => {
        setShowErrorMessageForLeaveToggle(false);
        setShowErrorMessageForPublicHolidayToggle(false);
    }

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-5 mb-2 p-0">
                        {
                            isPublicHolidayExistInPeriod && !isPublicHolidayExistsInAllWeeks &&
                            (
                                <div className="mb-1">
                                    <Switch size="small" defaultChecked={isPublicHolidayExistInPeriod} onLabel={""} offLabel={""} onChange={onExcludePublicHolidayChange} />
                                    <label className="form-check-label ms-2">Exclude weeks with public holidays</label>
                                </div>
                            )
                        }
                        {
                            !isPublicHolidayExistInPeriod && !isPublicHolidayExistsInAllWeeks &&
                            (
                                <div className="mb-1">
                                    <Switch size="small" onLabel={""} offLabel={""} disabled />
                                    <label className="form-check-label text-secondary ms-2">Exclude weeks with public holidays</label>
                                </div>
                            )
                        }
                        {
                            isPublicHolidayExistsInAllWeeks &&
                            (
                                <div className="mb-1">
                                    <Switch size="small" checked={!isPublicHolidayExistsInAllWeeks} onLabel={""} offLabel={""} onChange={onExcludePublicHolidayChange} />
                                    <label className="form-check-label ms-2">Exclude weeks with public holidays</label>
                                </div>
                            )
                        }
                        {showErrorMessageForPublicHolidayToggle && <span className="help-block mb-2 text-danger field-validation-valid">Public holidays occur in all weeks of the reporting period.</span>}
                        {
                            isLeaveExistInPeriod && !isLeaveExistsInAllWeeks &&
                            (
                                <div className="mb-0">
                                    <Switch size="small" defaultChecked={isLeaveExistInPeriod} onLabel={""} offLabel={""} onChange={onExcludeLeaveChange} />
                                    <label className="form-check-label ms-2">Exclude weeks with leave</label>
                                </div>
                            )
                        }
                        {
                            !isLeaveExistInPeriod && !isLeaveExistsInAllWeeks &&
                            (
                                <div className="mb-0">
                                    <Switch size="small" onLabel={""} offLabel={""} disabled />
                                    <label className="form-check-label text-secondary ms-2">Exclude weeks with leave</label>
                                </div>
                            )
                        }
                        {
                            isLeaveExistsInAllWeeks &&
                            (
                                <div className="mb-0">
                                    <Switch size="small" checked={!isLeaveExistsInAllWeeks} onLabel={""} offLabel={""} onChange={onExcludeLeaveChange} />
                                    <label className="form-check-label ms-2">Exclude weeks with leave</label>
                                </div>
                            )
                        }
                        {showErrorMessageForLeaveToggle && <span className="help-block m-b-none text-danger field-validation-valid">Leave occurs in all weeks of the reporting period.</span>}
                        {totalSessions == 0 && (<p>No activities in diary for this week.</p>)}
                    </div>
                    <div className="col-lg-5" onClick={hideErrorMessagesForLeaveAndPublicHoliday}></div>
                </div>

            </div>
            <div className="Container-fluid">
                <div className="row">
                    <div className="col-lg-6" onClick={reset}>
                        <Chart transitions={false} donutCenterRender={donutCenterRenderer} onSeriesClick={onSeriesClick} onSeriesHover={handleOnHoverState}>
                            <ChartTooltip render={renderTooltip} background="#fff" />
                            <ChartLegend visible={false} />
                            <ChartArea background="none" />
                            <ChartSeries>
                                <ChartSeriesItem
                                    name="subCategories"
                                    data={subCategories}
                                    width={500}
                                    type="donut"
                                    startAngle={0}
                                    field="totalSessions"
                                    categoryField="name"
                                    colorField="color"
                                    size={40}
                                    holeSize={50}
                                    margin={3}
                                >
                                </ChartSeriesItem>
                                <ChartSeriesItem
                                    name="categories"
                                    data={categories}
                                    width={500}
                                    type="donut"
                                    startAngle={0}
                                    field="totalSessions"
                                    categoryField="name"
                                    colorField="color"
                                    size={60}
                                    holeSize={50}
                                    margin={3}
                                >
                                </ChartSeriesItem>
                            </ChartSeries>
                        </Chart>

                        {dccExceedsContracted && (
                            <span className="red-text mb-2">
                                <svg className="bi bi-dash-circle-fill" width="16" height="16" fill="red" viewBox="0 0 16 16">
                                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7z" />
                                </svg>&nbsp;
                                <p className="mb-0">Average DCC is more than contracted hours.</p>
                            </span>
                        )}
                        {iccDccExceedsContracted && (
                            <span className="red-text mb-2">
                                <svg className="bi bi-dash-circle-fill" width="16" height="16" fill="red" viewBox="0 0 16 16">
                                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7z" />
                                </svg>&nbsp;
                                <p className="mb-0">Average total of DCC and ICC is more than contracted hours.</p>
                                <br />
                            </span>
                        )}
                        <div>
                            {iccPercentage > 0 && (
                                <p className="mb-1">Your average ICC is {iccPercentage.toFixed(0)}% of your DCC plus ICC time.</p>)}
                        </div>
                        <div>
                            {aggregateIccDccPercentage > 0 && iccPercentage > 0 && (
                                <p className="text-secondary mb-1">Other GP Diary users find ICC is {aggregateIccDccPercentage.toFixed(0)}% of DCC plus ICC time.</p>)}
                        </div>
                        <div>
                            {contractPercentage > 0 && (
                                <p className="mb-1">Your average contract hours are {contractPercentage.toFixed(0)}% of your worked total.</p>)}
                        </div>
                        <div>
                            {aggregateContractPercentage > 0 && contractPercentage > 0 && (
                                <p className="text-secondary mb-1">Other GP Diary users find their contract hours are {aggregateContractPercentage.toFixed(0)}% of their total hours.</p>)}
                        </div>
                    </div>
                    <div className="col-lg-2" onClick={reset}></div>
                    <div className="col-lg-4 mt-5">
                        {categories.map((item: any, index: any) => (
                            <Fragment key={index}>
                                <ExpansionPanel
                                    expandIcon="k-icon k-i-arrow-60-right"
                                    collapseIcon="k-icon k-i-arrow-60-down"
                                    style={{ border: 'none', borderBottom: "2px solid lightgrey" }}
                                    expanded={expanded[item.id]}
                                    tabIndex={0}
                                    key={item.id}
                                    onAction={onAction.bind(undefined, item.id)}
                                    title={
                                        <div className="row mt-2">
                                            <span className="mr-2">
                                                <svg width="50" height="50">
                                                    <circle cx="25" cy="25" r="25" fill={item.color} fillOpacity="0.3" />
                                                    <circle cx="25" cy="25" r="15" fill={item.color} fillOpacity="0.7" />
                                                    <circle cx="25" cy="25" r="5" fill={item.color} fillOpacity="1" />
                                                </svg>
                                                <label className="text-dark ps-2">{item.name} - {item.totalHours.toFixed(0)}h {item.totalMinutes.toFixed(1)}m ({item?.percentage > 0 ? item?.percentage?.toFixed(1) : 0}%)</label>
                                            </span>
                                        </div>
                                    }
                                />
                                {subCategories.filter((x: any) => x.categoryId == item.id).map((sub: any, index: any) => (
                                    <Fragment key={index}>
                                        {expanded[item.id] && (
                                            <div className="container-fluid">
                                                <ExpansionPanelContent>
                                                    <div className="row mt-2">
                                                        <span className="col-1 ps-4 ms-1">
                                                            <svg width="20" height="20">
                                                                <circle cx="10" cy="10" r="10" fill={sub.color} />
                                                            </svg>
                                                        </span>
                                                        <label className="col-5 ps-4 ms-1 pe-0 text-break">{sub.name}</label>
                                                        <label className="col-5 ps-1 pe-0 text-break">{sub.totalHours.toFixed(0)}h {sub.totalMinutes.toFixed(1)}m ({sub?.percentage > 0 ? sub?.percentage?.toFixed(1) : 0}%)</label>
                                                    </div>
                                                </ExpansionPanelContent>
                                            </div>
                                        )}
                                    </Fragment>
                                ))}
                            </Fragment>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
}